import { Button } from "./ui/button";
import { useLanguage } from "../contexts/LanguageContext";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Globe } from "lucide-react";
import YimnakNavigationLauncher from "./YimnakNavigationLauncher";

export default function Navbar() {
  const { t } = useTranslation();
  const { language, setLanguage, dir } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === "ar" ? "en" : "ar");
  };

  return (
    <nav
      className="yimnak-landing-navbar fixed top-0 inset-x-0 z-50 border-b"
      dir={dir}
      style={{
        backgroundColor: "var(--yimnak-header-surface)",
        borderColor: "var(--yimnak-header-border)",
      }}
    >
      <div className="container mx-auto px-4 h-16 flex items-center justify-between gap-3">
        <Link
          to="/"
          className="text-xl font-bold transition-colors"
          style={{ color: "var(--yimnak-header-title)" }}
        >
          {t("brand.name")}
        </Link>

        <div className="flex items-center gap-3">
          <YimnakNavigationLauncher variant="landing" />

          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={toggleLanguage}
            className="yimnak-landing-navbar__lang-btn"
            aria-label="Toggle language"
          >
            <Globe className="h-5 w-5" />
          </Button>
        </div>
      </div>
    </nav>
  );
}
